const API_ROUTES = {
  availability: "/v1/availability",
};
export { API_ROUTES };
